
jQuery(function($){

// Home Banner Slider
$('#banner-slider').owlCarousel({
  autoplay:true,
  autoplayTimeout: 3800,
  margin: 10,
  loop: true,
  responsive: {
    0: {
      items: 1
    },
    600: {
      items: 1
    },
    1000: {
      items: 1
    }
  }
});

// Collection Slider
$(".collectionslider").owlCarousel({
    loop: true,
    margin: 0,
    dots: true,
    nav: true,
    autoplay: true,
    slideBy: 1,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
      },
      480: {
        items: 2,
      },
      800: {
        items: 3,
      },
      1200: {
        items: 4,
      },
    },
  });

// Trending Slider
$("#trendslider").owlCarousel({
    loop: true,
    margin: 0,
    dots: true,
    nav: true,
    autoplay: true,
    slideBy: 1,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
      },
      480: {
        items: 2,
      },
      1024: {
        items: 2,
      },
      1200: {
        items: 2.5,
      },
    },
  });

  // product-details-expand
  $(".expandTitle").click(function () {
    $(".details").slideUp();
    $(".expandTitle").removeClass("open");
    if ($(this).next(".details").is(":hidden")) {
      jQuery(this).next(".details").slideDown();
      $(this).select(".expandTitle").addClass("open");
    } else {
      jQuery(this)
        .next(".details")
        .slideUp(function () {
          $(".expandTitle").removeClass("open");
        });
    }
  });

  
});